import { WorkBook } from "xlsx-js-style";
import { ExcelTemplate } from "../../../interfaces";
import * as XLSX from 'xlsx-js-style';
import { getPreparedData } from "./mapping";
import { fitToColumn } from "../../financial-statement/utils";
import { setColumnWidth } from "../../../utils";
import {
  MetricCrossCompanyExportExcel,
} from "../../../../kpi/components/kpi-metrics-main/cross-company/kpi-cross-company.component";

export class KpiCrossCompanyTemplate implements ExcelTemplate {
  export(data: MetricCrossCompanyExportExcel): WorkBook {
    const book = XLSX.utils.book_new();
    const sheet = this.getSheet(data);
    XLSX.utils.book_append_sheet(book, sheet);
    return book;
  }

  getSheet(data: MetricCrossCompanyExportExcel): XLSX.WorkSheet {
    const preparedData = getPreparedData(data);
    const sheet = {
      ...XLSX.utils.aoa_to_sheet(preparedData),
      '!cols': fitToColumn(preparedData),
    };
    const whiteSpaceIndex = [3];
    const largeColumn = [0, 2];
    const mediumColumn = [1]; // Role column
    whiteSpaceIndex.forEach((index) => setColumnWidth(sheet, index, 1.5));
    largeColumn.forEach((index) => setColumnWidth(sheet, index, 30));
    mediumColumn.forEach((index) => setColumnWidth(sheet, index, 15));

    // Make period columns more narrow
    // Period columns start from index 4 (after Metric, Role, Company, and null columns)
    for (let i = 0; i < data.periods.length; i++) {
      setColumnWidth(sheet, i + 4, 15);
    }

    return (sheet);
  }
}
